<template>
  <button class="file-select">
    <span>
      <span v-if="progress">{{progress}}%</span>
      <span v-else-if="label">{{label}}</span>
      <span v-else>Choose {{multiple ? 'files' : 'file'}}</span>
    </span>
    <span v-if="multiple">
      <input type="file" id="file" ref="file" v-on:change="onFileSelect" multiple />
    </span>
    <span v-else>
      <input type="file" id="file" ref="file" v-on:change="onFileSelect" />
    </span>
    <small>{{callToAction}}</small>
  </button>
</template>

<script>
export default {
  name: 'FileSelect',
  props: {
    multiple: Boolean,
    progress: Number,
    label: String,
  },
  computed: {
    callToAction() {
      const uploadStatus = this.progress === 100 ? 'Processing' : 'Uploading';
      return this.progress ? uploadStatus : 'Click to select';
    },
  },
  methods: {
    onFileSelect() {
      const { files } = this.$refs.file;
      const file = files[0];
      this.$emit('select', this.multiple ? files : file);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.file-select {
  text-align: center;
  position: relative;
  padding: 20px;
  border-radius: var(--radius);
  position: relative;
  display: block;
  text-decoration: none;
  appearance: none;
  background: var(--color-light);
  color: var(--color-dark);
  border: dashed 2px var(--color-link-inactive);
  border-radius: var(--radius);
  width: 100%;
  &:hover {
    background: rgba(0,0,0,0.03);
    color: var(--color-link);
    border-color: var(--color-link);
  }
  span {
    display: block;
  }
  span > input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    z-index: 1;
    cursor: pointer;
  }
  small {
    display: block;
    font-weight: normal;
    color: var(--color-link-inactive);
    margin-top: 5px;
  }
}
</style>
